import { defineMessages } from 'react-intl';

export const RATING_MESSAGE = {
    id: 'Profile.Page.Components.RatingMessage',
    defaultMessage: 'After a patient attends an appointment booked through Zocdoc, we ask them to leave feedback. Here’s what we asked:',
};

export const OVERALL_RATING_STRINGS = defineMessages({
    Label: {
        id: 'Profile.Page.Components.OverallRatingText',
        defaultMessage: 'Overall',
    },
    Tooltip: {
        id: 'Profile.Page.Components.OverallRatingTooltipText',
        defaultMessage: 'Would you recommend the professional who treated you?',
    },
    Stars1: {
        id: 'Profile.Page.Components.OverallRating1StarText',
        defaultMessage: '1 star = Never!',
    },
    Stars2: {
        id: 'Profile.Page.Components.OverallRating2StarText',
        defaultMessage: '2 stars = Probably Not',
    },
    Stars3: {
        id: 'Profile.Page.Components.OverallRating3StarText',
        defaultMessage: '3 stars = Maybe',
    },
    Stars4: {
        id: 'Profile.Page.Components.OverallRating4StarText',
        defaultMessage: '4 stars = Probably',
    },
    Stars5: {
        id: 'Profile.Page.Components.OverallRating5StarText',
        defaultMessage: '5 stars = Highly Recommended',
    },
});

export const BEDSIDE_MANNER_STRINGS = defineMessages({
    Label: {
        id: 'Profile.Page.Components.BedsideRatingText',
        defaultMessage: 'Bedside manner',
    },
    Tooltip: {
        id: 'Profile.Page.Components.BedsideRatingTooltipText',
        defaultMessage: 'How would you rate the professional’s bedside manner? ',
    },
    Stars1: {
        id: 'Profile.Page.Components.BedsideRating1StarText',
        defaultMessage: '1 star = Awful',
    },
    Stars2: {
        id: 'Profile.Page.Components.BedsideRating2StarText',
        defaultMessage: '2 stars = Unsatisfactory',
    },
    Stars3: {
        id: 'Profile.Page.Components.BedsideRating3StarText',
        defaultMessage: '3 stars = Satisfactory',
    },
    Stars4: {
        id: 'Profile.Page.Components.BedsideRating4StarText',
        defaultMessage: '4 stars = Good',
    },
    Stars5: {
        id: 'Profile.Page.Components.BedsideRating5StarText',
        defaultMessage: '5 stars = Excellent',
    },
});

export const WAIT_TIME_STRINGS = defineMessages({
    Label: {
        id: 'Profile.Page.Components.WaitTimeRatingText',
        defaultMessage: 'Wait time',
    },
    Tooltip: {
        id: 'Profile.Page.Components.WaitTimeRatingTooltipText',
        defaultMessage: 'How long was the wait time in the office before you were seen? ',
    },
    Stars1: {
        id: 'Profile.Page.Components.WaitTimeRating1StarText',
        defaultMessage: '1 star = More than 2 hours',
    },
    Stars2: {
        id: 'Profile.Page.Components.WaitTimeRating2StarText',
        defaultMessage: '2 stars = More than 1 hour',
    },
    Stars3: {
        id: 'Profile.Page.Components.WaitTimeRating3StarText',
        defaultMessage: '3 stars = Between 30 and 60 minutes',
    },
    Stars4: {
        id: 'Profile.Page.Components.WaitTimeRating4StarText',
        defaultMessage: '4 stars = Less than 30 minutes',
    },
    Stars5: {
        id: 'Profile.Page.Components.WaitTimeRating5StarText',
        defaultMessage: '5 stars = Right Away!',
    },
});

export const LOCALIZED_STRINGS = defineMessages({
    BasedOnReviews: {
        id: 'Profile.Page.Components.ReviewCount',
        defaultMessage: `Based on {numberOfReviews, plural,
            one {# review}
            other {# reviews}
        }`,
    },
    ReviewsHeader: {
        id: 'Profile.Page.Components.ReviewsHeader',
        defaultMessage: 'Patient reviews',
    },
    ReviewsLegend: {
        id: 'Profile.Page.Components.VerifiedPatientText',
        defaultMessage: 'All reviews have been submitted by patients after seeing the provider. For more information, check out our Patient Knowledge Base.',
    },
    ShowMoreReviews: {
        id: 'Profile.Page.Components.ShowMoreReviewsText',
        defaultMessage: 'show all reviews',
    },
    BackToTop: {
        id: 'Profile.Page.Components.BackToTopText',
        defaultMessage: 'back to top',
    },
    ProfileTabLabel: {
        id: 'Profile.Page.Components.ProfileTabLabel',
        defaultMessage: 'Overview',
    },
    ReviewsTabLabel: {
        id: 'Profile.Page.Components.ReviewsTabLabel',
        defaultMessage: 'Patient reviews',
    },
    OfficeLocationsTooltip: {
        id: 'Profile.Page.Components.OfficeLocationsTooltip',
        defaultMessage: 'The location where the provider practices and the contact information for the location. This information is provided to the Health Plan by the provider and validated at least every three years or more frequently as updates are provided. The Health Plan contacts all providers on a quarterly basis to request accurate information.',
    },
    NoOfficeLocations: {
        id: 'Profile.Page.Components.NoOfficeLocations',
        defaultMessage: 'Phone number: N/A',
    },
    ProviderOptedOut: {
        id: 'Profile.Page.Components.ProviderOptedOut',
        defaultMessage: 'This doctor has chosen not to have their reviews shown on Zocdoc.',
    },
    ReviewsSummaryTitle: {
        id: 'Profile.Page.Components.ReviewsSummaryTitle',
        defaultMessage: 'Patients reviews summary',
    },
});
